import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Drawer, Loader } from "@/atoms";
import { TrackForm } from "@/components";
import { actionsData } from "@/data";
import { useEditTrack, useGetTrack } from "@/hooks";
import { toggleTrackDrawer } from "@/redux/actions";

const TrackDrawer = ({ id, setId }) => {
    const { t } = useTranslation();

    const open = useSelector((state) => state.tracksReducer?.openDrawer);

    const dispatch = useDispatch();

    const { data, loading } = useGetTrack(id);

    const { editTrack, loading: editTrackLoading } = useEditTrack(data?.trackFileId, id, setId);

    const {
        artist,
        custom_id: customId,
        downloadUri,
        image,
        isrc,
        isrc_other: otherIsrc,
        iswc,
        originalTrackId,
        releaseTracks,
        secondary_artists: secondaryArtists,
        title,
        title_ar: nameAr,
        track_num: trackNum,
        trackContributorRoles,
        trackFile,
        trackFormat,
    } = data || {};

    const allReleaseTracks = releaseTracks?.[0]?.release?.releaseTracks?.map((rt) => rt.track) || [];
    const originalTrackData = allReleaseTracks.find((t) => t.id === originalTrackId);

    const formValues = {
        customId,
        imageFile: image?.id,
        isrc,
        iswc,
        nameAr,
        nameEn: title,
        number: trackNum,
        oldImage: image,
        oldTrack: downloadUri,
        originalTrack: originalTrackId,
        hasOriginalTrack: !!originalTrackId,
        originalTrackObj: originalTrackId
            ? {
                  label: originalTrackData?.title || "Unknown",
                  value: originalTrackId,
              }
            : null,
        otherIsrc,
        primaryArtist: artist?.id,
        primaryArtistObj: {
            label: artist?.name,
            value: artist?.id,
        },
        secondaryArtists: secondaryArtists?.map(({ id: artistId }) => ({ id: artistId })),
        secondaryArtistsArray: secondaryArtists?.map(({ id: artistId, name }) => ({
            label: name,
            value: artistId,
        })),
        track: id,
        trackContributorRoles: trackContributorRoles?.map(({ contributors, role }) => ({
            contributors: contributors?.map(({ id: contributorId, name: contributorName }) => ({
                label: contributorName,
                value: contributorId,
            })),
            role: {
                label: role.name,
                value: role.id,
            },
        })),
        trackFile: trackFile?.id,
        trackFormat: trackFormat?.id,
        trackFormatObj: {
            label: trackFormat?.displayName,
            value: trackFormat?.id,
        },
    };

    return (
        <Drawer
            closeAction={() => dispatch(toggleTrackDrawer(false))}
            open={!!(open && id)}
            title={t("tracks.editTrack")}
        >
            {loading ? (
                <Loader />
            ) : (
                <TrackForm
                    action={actionsData.edit}
                    loading={editTrackLoading}
                    values={formValues}
                    hasDrawer
                    onSubmitForm={editTrack}
                />
            )}
        </Drawer>
    );
};

export default TrackDrawer;

TrackDrawer.propTypes = {
    id: PropTypes.number,
    setId: PropTypes.func,
};
